import { render, staticRenderFns } from "./titktokRecommends.vue?vue&type=template&id=7ceecd5a&"
import script from "./titktokRecommends.vue?vue&type=script&lang=js&"
export * from "./titktokRecommends.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports